import { getImageUrl } from '@/utils/getImageUrl'

interface Video {
  id: number;
  thumbnailUrl: string;
  profileUrl: string;
  title: string;
  description: string;
  company: string;
  name: string;
  duty: string;
  videoUrl: string;
}

export const videos: Video[] = [
  {
    id: 1,
    thumbnailUrl: getImageUrl('landing/video1.png'),
    profileUrl: getImageUrl('landing/profile1.png'),
    title: '허위 광고라고 생각했었는데..',
    description: '혜움의 더낸세금은 믿을 수 있는 세무법인 서비스라고 추천받아서 하게 됐어요.',
    company: '건강나라약국',
    name: '이승기',
    duty: '약사',
    videoUrl: 'https://www.youtube.com/embed/U2JXGxr8LFM',
  },
  {
    id: 2,
    thumbnailUrl: getImageUrl('landing/video2.png'),
    profileUrl: getImageUrl('landing/profile2.png'),
    title: '환급액이 놀라워요',
    description: '환급액 조회하고 깜짝 놀랐어요. 생각지도 못한 금액이 나와서요.',
    company: '한국 디비케이',
    name: '이소은',
    duty: '상무',
    videoUrl: 'https://www.youtube.com/embed/UzXXuwbXNg0',
  },
  {
    id: 3,
    thumbnailUrl: getImageUrl('landing/video3.png'),
    profileUrl: getImageUrl('landing/profile3.png'),
    title: '일단 한번 해보세요',
    description: '더 낸 세금이 있다는걸 알고 충격 먹었죠. 모르면 지나쳤을 환급금 받아서 좋아요.',
    company: '그란구스또',
    name: '장익수',
    duty: '대표',
    videoUrl: 'https://www.youtube.com/embed/yG7hupyiAsc',
  },
  {
    id: 4,
    thumbnailUrl: getImageUrl('landing/video4.png'),
    profileUrl: getImageUrl('landing/profile4.png'),
    title: '환급금을 보는 순간 감동',
    description: '환급금을 보는 순간 감동이었어요. 이렇게 많이 나올줄 몰랐어요.',
    company: '유정삼겹',
    name: '임유정',
    duty: '대표',
    videoUrl: 'https://www.youtube.com/embed/86mpVUPOleE',
  },
  {
    id: 5,
    thumbnailUrl: getImageUrl('landing/video5.png'),
    profileUrl: getImageUrl('landing/profile5.png'),
    title: '편하게 환급 받았어요',
    description: '서류제출이나 전화할 필요 없이 비대면, 모바일로 진행해서 편하고 좋았어요.',
    company: '법무법인J&F',
    name: '임완수',
    duty: '변호사',
    videoUrl: 'https://www.youtube.com/embed/rKoCp59wPyQ',
  },
  {
    id: 6,
    thumbnailUrl: getImageUrl('landing/video6.png'),
    profileUrl: getImageUrl('landing/profile6.png'),
    title: '공돈 생기는데 안할 이유 없죠',
    description: '더낸세금 매년 할 계획이에요. 환급 조회가 무료니까 꼭 해봐야죠.',
    company: '필드키친',
    name: '강규원',
    duty: '대표',
    videoUrl: 'https://www.youtube.com/embed/4uWO5eVnk6Y',
  },
]
